import React from 'react';
import useCanonicalUrl from '../hooks/useCanonicalUrl';

/**
 * CanonicalUrl Component
 * A component that automatically manages canonical URLs for SEO
 * @param {string} customUrl - Optional custom canonical URL
 * @param {string} baseUrl - Optional base URL for canonical links
 */
const CanonicalUrl = ({ customUrl, baseUrl }) => {
  useCanonicalUrl(customUrl, baseUrl);
  return null; // This component doesn't render anything
};

export default CanonicalUrl;